import React from 'react'
import Layout from '../components/global/Layout'
import Banner from '../components/home/Banner'
import LiveToken from '../components/home/LiveToken'
import UpcomingToken from '../components/home/UpcomingToken'
import Features from '../components/home/Features'
import TokenMics from '../components/home/TokenMics'
import ZtgmDiagram from '../components/home/ZtgmDiagram'
import Roadmap from '../components/home/Roadmap'
import FAQ from '../components/home/FAQ'
import useApi from '../hook/useApi'

const Home = () => {

  const { data: metrics, loading } = useApi(
    'GET',
    'player/metrics',
    undefined,
  );

  return (
    <div>
      <Layout hide={loading}>
        <Banner metrics={metrics}/>
        <LiveToken metrics={metrics} />
        <UpcomingToken />
        <Features />
        <TokenMics />
        <ZtgmDiagram />
        <Roadmap />
        <FAQ />
      </Layout>
    </div>
  )
}

export default Home